import { Modal } from 'react-bootstrap';
import { getHtml } from '../../../helper';

const EmailModal = ({showModal, setShowModal, message}) => {
  return (
    <Modal
      show={showModal}
      animation
      size="lg"
      centered
    >
      <Modal.Header>
        <Modal.Title>Subject : {message?.emailDetails?.subject || "No Subject"}</Modal.Title>
        <span className="modal_close" onClick={() => setShowModal()}><i className="icon-cross" /></span>
      </Modal.Header>
      <Modal.Body className="card p-3">
        <div className='email_msg'>{getHtml(message.message)}</div>
        {message?.emailDetails?.attachments?.length > 0 &&
          <div className='mt-3'>
          <p><b>Attachments :</b></p>
          {
            message?.emailDetails?.attachments?.map(i =>
              <a href={i?.fileUrl ?? i?.url} target="_blank" rel="noreferrer">
                <i style={{fontSize:25}} className="icon-folder mx-1"></i>
              </a>
          )}
          </div>
        }
      </Modal.Body>
    </Modal>
  )
}

export default EmailModal
